
<div class="Section ProblemSolutionSection" id="problem-solution">
    <div class="SectionContainer">
        <div class="SectionHeader">
            <h2 class="SectionTitle">
                <span class="TitleAccent">Ihre Probleme, unsere Lösungen</span>
                Für ein effizienteres Taxiunternehmen
            </h2>
        </div>

        <div class="ColumnHeaders">
            <div class="ColumnHeader ProblemHeader">
                <div class="HeaderIcon">
                    <i class="ri-close-circle-line"></i>
                </div>
                <span>Ohne TaxiFusion</span>
            </div>
            <div class="ColumnHeader SolutionHeader">
                <div class="HeaderIcon">
                    <i class="ri-checkbox-circle-fill"></i>
                </div>
                <span>Mit TaxiFusion</span>
            </div>
        </div>

        <div class="ProblemSolutionGrid">
            <!-- Problem-Solution Pair #1 -->
            <div class="ProblemSolutionPair">
                <div class="ProblemColumn">
                    <div class="ProblemCard">
                        <div class="ProblemTag">Problem #1</div>
                        <div class="CardIcon">
                            <i class="ri-shield-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Gesetzliche Vorgaben</h3>
                            <div class="ProblemImpact">
                                <i class="ri-file-damage-line"></i>
                                <span>Bußgelder bis zu 25.000€</span>
                            </div>
                            <p>
                                Ständig wechselnde Anforderungen (INSIKA/TSE) führen zu hohen
                                Bußgeldern bei Nichteinhaltung.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="ConnectorLine">
                    <div class="ConnectorDot"></div>
                    <div class="ConnectorArrow">
                        <i class="ri-arrow-right-line"></i>
                    </div>
                </div>

                <div class="SolutionColumn">
                    <div class="SolutionCard">
                        <div class="SolutionTag">Lösung #1</div>
                        <div class="CardIcon">
                            <i class="ri-shield-check-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Gesetzeskonform mit TaxiFusion</h3>
                            <div class="SolutionImpact">
                                <i class="ri-shield-check-line"></i>
                                <span>100% rechtlich abgesichert</span>
                            </div>
                            <p>
                                TaxiFusion hält Sie stets aktuell mit TSE-Anforderungen – ohne
                                zusätzlichen Aufwand für Sie.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Problem-Solution Pair #2 -->
            <div class="ProblemSolutionPair">
                <div class="ProblemColumn">
                    <div class="ProblemCard">
                        <div class="ProblemTag">Problem #2</div>
                        <div class="CardIcon">
                            <i class="ri-admin-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Aufwändige Verwaltung</h3>
                            <div class="ProblemImpact">
                                <i class="ri-timer-line"></i>
                                <span>15+ Stunden/Woche verschwendet</span>
                            </div>
                            <p>
                                Zeitverschwendung durch komplizierte Software, die mehr Probleme
                                verursacht als löst.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="ConnectorLine">
                    <div class="ConnectorDot"></div>
                    <div class="ConnectorArrow">
                        <i class="ri-arrow-right-line"></i>
                    </div>
                </div>

                <div class="SolutionColumn">
                    <div class="SolutionCard">
                        <div class="SolutionTag">Lösung #2</div>
                        <div class="CardIcon">
                            <i class="ri-dashboard-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Einfache Verwaltung mit TaxiFusion</h3>
                            <div class="SolutionImpact">
                                <i class="ri-timer-line"></i>
                                <span>15+ Stunden/Woche gespart</span>
                            </div>
                            <p>
                                TaxiFusion bietet intuitive Software, die Ihre
                                Verwaltungsaufgaben vereinfacht und automatisiert.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Problem-Solution Pair #3 -->
            <div class="ProblemSolutionPair">
                <div class="ProblemColumn">
                    <div class="ProblemCard">
                        <div class="ProblemTag">Problem #3</div>
                        <div class="CardIcon">
                            <i class="ri-time-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Hohe versteckte Kosten</h3>
                            <div class="ProblemImpact">
                                <i class="ri-money-euro-circle-line"></i>
                                <span>Bis zu 2.500€ Mehrkosten/Jahr</span>
                            </div>
                            <p>
                                Verpasste Fristen für P-Scheine und wichtige Dokumente führen zu
                                hohen finanziellen Einbußen.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="ConnectorLine">
                    <div class="ConnectorDot"></div>
                    <div class="ConnectorArrow">
                        <i class="ri-arrow-right-line"></i>
                    </div>
                </div>

                <div class="SolutionColumn">
                    <div class="SolutionCard">
                        <div class="SolutionTag">Lösung #3</div>
                        <div class="CardIcon">
                            <i class="ri-money-euro-circle-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Intelligente Erinnerungen mit TaxiFusion</h3>
                            <div class="SolutionImpact">
                                <i class="ri-money-euro-circle-line"></i>
                                <span>Bis zu 2.500€ gespart/Jahr</span>
                            </div>
                            <p>
                                TaxiFusion sendet intelligente Benachrichtigungen für P-Scheine,
                                TÜV und mehr, um Ihre Einnahmen zu sichern.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CTA Card from Solution.vue -->
        <div class="SolutionCTACard">
            <div class="CTACardContent">
                <div class="CTACardHeader">
                    <div class="CTAIcon">
                        <i class="ri-rocket-line"></i>
                    </div>
                    <h3>Starten Sie Ihr effizienteres Taxiunternehmen</h3>
                </div>

                <div class="CTACardBody">
                    <p>
                        <span class="Highlight">TaxiFusion</span> ist mehr als nur eine
                        Verpflichtung zur Datenspeicherung. Unser Ziel ist es, Ihnen die
                        Werkzeuge an die Hand zu geben, die Sie benötigen, um Ihr Geschäft
                        effizienter und rentabler zu gestalten.
                    </p>
                    <router-link to="/register">
                        <Button size="large">
                            Jetzt Registrieren <i class="ri-arrow-right-line"></i>
                        </Button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</div>
